// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"90f73b4e","60":"a9b360ae","460":"0a712ea4","590":"e98bc021","641":"3e4c5659","693":"79e375cc","704":"a0c5cf79","824":"cc082f92"}[chunkId] + ".chunk.js";
};